import { UserIcon } from '@phosphor-icons/react';

export interface IUserIdentityCellProps {
  /** Display name, or a placeholder when the account has no name yet. */
  name: React.ReactNode;
  image?: string | null;
}

/**
 * Name cell of a user row — round avatar tile beside the name. A user without
 * an avatar gets the neutral user glyph rather than an empty gap.
 */
export const UserIdentityCell: React.FC<IUserIdentityCellProps> = ({ name, image }) => {
  return (
    <div className="flex min-w-0 items-center gap-2.5">
      {image ? (
        <img src={image} alt="" className="h-7 w-7 shrink-0 rounded-full object-cover" />
      ) : (
        <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-neutral-subtle">
          <UserIcon className="h-3.5 w-3.5 text-fg-muted" />
        </div>
      )}
      <span className="truncate text-sm font-semibold text-fg">{name}</span>
    </div>
  );
};
